export const MAX_NBR_ADDRESSES_PER_CONTACT = 5;
